import $ from "jquery";

// When the user scrolls the page, execute myFunction
window.onscroll = function() {
  scrolling();
};

var navbarMaxHeight = 0;
var navbarMinHeight = 0;

var $navbar = $(".navbar--desktop");
var $navbarSpacer = $(".navbar-spacer--desktop");
var offset = $navbar[0].offsetTop;

function getHeight($navbar) {
  return $navbar.outerHeight();
}

function scrolling() {
  if ($navbar.hasClass("stuck")) {
    navbarMinHeight = $navbar.outerHeight();
  } else {
    navbarMaxHeight = $navbar.outerHeight();
  }
  // console.log(window.pageYOffset);
  if (window.pageYOffset >= offset + navbarMaxHeight) {
    $navbar.addClass("stuck");
    $navbarSpacer.addClass("stuck");
  } else {
    $navbar.removeClass("stuck");
    $navbarSpacer.removeClass("stuck");
  }
}
